import Api from './api.service'

export default {
  createJournalClub (object) {
    return Api().post('journalClub/create', object)
  },
  updateJournalClub (object) {
    return Api().put('journalClub/edit/' + object.id, object.object)
  },
  journalClubList (filter) {
    return Api().get('journalClub/get', { params: filter })
  },
  getJournalClub (id) {
    return Api().get('journalClub/get/' + id)
  }
}
